import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { each, orderBy, findIndex, indexOf, find, map } from 'lodash';
import DatePicker from 'react-datepicker';
import Helmet from 'react-helmet';
import moment from 'moment';
import Fa from 'react-fontawesome';
import { Tab, Tabs, FormGroup, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';
import SearchForm from '../../../../components/search-form';
import BodyClassName from 'react-body-classname';
import ProgressBar from '../../../../components/progress-bar';
import IncludeOpenOpportunities from '../../components/include-open-opportunities';
import OpportunityModal from '../../../Analysic/components/opportunity-modal';
import SubNav from '../../components/nav';
import RequiredTVCollectorMappingSetup from '../../../Setup/pages/TruVoiceCollectorsPage/RequiredTVCollectorMappingSetup';
import AutomationSelector from '../../components/automation-selector';
import { fetchAllFeedbackRequestAutomations } from '../../../Setup/SetupActions';
import ProgressStats from '../../components/progress-stats';
import ProgressSummary from '../../components/progress-summary';
import AccountModal from '../../../Dashboard/components/AccountTable/modal';
import OwnerTable from '../../components/owner-table';
import ResourceTable from '../../components/resource-table';
import ReminderTable from '../../components/reminder-table';
import ContactTable from '../../components/contact-table';
import ResourceBox from '../../components/resource-box';

import styles from './styles.css';

import {
  resetAll,
  fetchFeedbackOpportunities,
  loadSettings,
  fetchFeedbackExperienceOpportunities,
} from '../../../Dashboard/DashboardActions';

import {
  getUser,
} from '../../../Auth/AuthReducer';

import {
  getWinLossLoading,
  getWinLossLoaded,
  getWinLossErrors,
  getWinLossOpportunities,
  getWinLossAccounts,
  getProgressStats,
  getFeedbackRequestSettings,
  getProgressLoadError,
  getProgressLoadPercentage,
} from '../../../Dashboard/DashboardReducer';
class ProgressPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      automations: [],
      automation: null,
      isAccount: false,
      selectedIds: null,
      ready: false,
      viewingResource: null,
      showDetailModal: false,
      hasReset: false,
      dateAnchor: moment(),
    };
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleSelectAutomation = this.handleSelectAutomation.bind(this);
    this.handleShowStats = this.handleShowStats.bind(this);
    this.getColDefs = this.getColDefs.bind(this);
    this.handleStatusCellClick = this.handleStatusCellClick.bind(this);
    this.hanldeReset = this.hanldeReset.bind(this);
  }


  componentDidMount() {
    this.loadAutomations();
  }

  handleShowStats(ids) {
    if (ids && ids.length > 0) {
      this.setState({ selectedIds: ids });
    } else {
      this.setState({ selectedIds: null });
    }
  }

  hanldeReset() {
    this.setState({ hasReset: true });
  }


  handleStatusCellClick(params) {
    this.setState({ viewingResource: params?.data, showDetailModal: true });
  }

  checkRelativeDateFilters(automations) {
    const nodeChecker = (node) => {
      if (node?.type === 'groupAND' || node?.type === 'groupOR') {
        return indexOf(map(node.values, (val) => nodeChecker(val)), true) >= 0;
      } else if ((node?.control_type === 'pre_defined_range' || node?.control_type === 'relative_range') && (node?.type === 'include' || node?.type === 'exclude')) {
        return true;
      }
      return false;
    };
    each(automations, (automation) => {
      automation.$has_date_filters = nodeChecker(automation.search_query);
    });
  }


  loadAutomations() {
    this.setState({ loading: true, loaded: false, error: null, automations: [], automation: null }, () => {
      this.props.dispatch(fetchAllFeedbackRequestAutomations())
        .then(
          ({ settings }) => {
            const allAutomations = [...settings];
            allAutomations.push({
              enabled: true,
              name: 'No Automation Group',
              is_system: false,
              source: 'opportunity',
              _id: 'opportunities',
              sort_order: 1000,
              is_empty: true,
            });

            allAutomations.push({
              enabled: true,
              name: 'No Automation Group',
              is_system: false,
              source: 'account',
              _id: 'accounts',
              sort_order: 1000,
              is_empty: true,
            });

            this.checkRelativeDateFilters(allAutomations);
            const automations = orderBy(allAutomations, [
              (a) => {
                if (a.source === 'opportunity') {
                  return 0;
                }
                return 1;
              }, 
              'sort_order'
            ], ['asc', 'asc']);

            // select first default and active, otherwise, select active
            
            /*
            const defaults = [
              { is_system: true, enabled: true, source: 'opportunity' },
              { enabled: true, source: 'opportunity' },
              { is_system: true, enabled: true, source: 'account' },
              { enabled: true, source: 'account' },
            ];
            */

            const defaults = [
              { is_system: true, enabled: true },
              { enabled: true },
            ];

            let automation = null;
            each(defaults, (params) => {
              if (!automation) {
                const index = findIndex(automations, params);
                if (index >= 0) {
                  automation = automations[index];
                }
              }
            });
            if (!automation) {
              automation = automations[0]; // first one
            }
            this.setState({ 
              loading: false, 
              loaded: true, 
              automations, 
            }, () => {
              this.handleSelectAutomation(automation);
            });
          },
          (error) => {
            this.setState({ loading: false, loaded: true, error: error.data ? error.data.message : error });
          },
        );
    });
  }

  handleAutomationLoaded(automations) {
    this.setState({ automations, loading: false, loaded: true, hasReset: false });
  }

  handleSelectAutomation(automation) {
    this.setState({ automation, isAccount: automation?.source === 'account', hasReset: false });
  }

  handleFormChange(criteria) {
    const { hasNoDecision } = this.props;
    const { isAccount } = this.state;
    this.setState({ query: null, selectedFilter: null, selectedTab: 'summary', viewType: null, ready: false, viewingResource: null });
    this.props.dispatch(resetAll(false))
      .then(() => {
        this.setState({ tabs: {}, colorPalletes: {} });
        this.props.dispatch(loadSettings(null, isAccount))
          .then(
            () => {
              const include = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'products', 'accountIndustries', 'internalEmailCount'];
              const action = isAccount ? fetchFeedbackExperienceOpportunities({ ...criteria }, hasNoDecision) : fetchFeedbackOpportunities({ ...criteria }, hasNoDecision, include);
              this.props.dispatch(action)
                .then(
                    (results) => {
                      const { opportunities, total } = results;
                      const returnResults = opportunities.length;
                      if (total && returnResults < total) {
                        const el = (
                          <div>
                            Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                            For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
                          </div>
                        );
                        this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
                      }
                      this.setState({ ready: true });
                    },
                    () => {
                      // TODO: handle error on search
                      this.setState({ ready: true });
                    },
                  );
            },
            () => {
              // TODO: handle error on load settings
              this.setState({ ready: true });
            },
          );
      });
  }


  getColDefs(column) {
    const col = ResourceTable.getColDefs(column);
    if (col && column.tag === 'status') {
      return {
        ...col,
        onCellClicked: this.handleStatusCellClick,
      };
    }
    return null;
  }

  renderModal() {
    const { isAccount, viewingResource } = this.state;
    const { opportunities, accounts } = this.props;
    
    if (viewingResource) {
      const keyName = isAccount ? 'account_id' : 'opportunity_id';
      const resource = find(isAccount ? accounts : opportunities, { [keyName]: viewingResource[keyName] });
      if (resource) {
        return (
          <ResourceBox
            key={resource[keyName]}
            resource={resource}
            isAccount={isAccount}
            automation={this.state.automation}
            modalMode
            showModal={this.state.showDetailModal}
            closeModal={() => {
              this.setState({ showDetailModal: false });
            }}
          />
        );
      }
    }
    return null;
  }



  renderResults() {
    const { isAccount, dateAnchor, automation } = this.state;
    const { opportunities, loaded, progressLoadError, loadPercentage, progressStats } = this.props;
    if (!loaded) {
      return null;
    }

    if (opportunities.length === 0) {
      return (
        <div>
          <div className="alert alert-warning">No results found.</div>
        </div>
      );
    }

    let key = '';
    if (automation) {
      key = automation._id;
      if (dateAnchor) {
        key = `${key}-${dateAnchor.format('YYYYMMDD')}`;
      }
    }
    return (
      <div>
        <div>
          <ProgressStats 
            key={key}
            automation={automation}
            resources={opportunities}
            showStats={this.handleShowStats}
            dateAnchor={dateAnchor}
          />
        </div>
        <p />
        {!progressLoadError &&
          <div>
            <Tabs
              defaultActiveKey={this.state.selectedTab}
              id="progress-tabs"
              animation
              mountOnEnter
              unmountOnExit
              onSelect={this.onTabSelect}
            >
              <Tab
                eventKey="summary"
                title="Summary"
              >
                <div style={{ paddingBottom: '40px' }}>
                  <p />
                  <ProgressSummary 
                    key={this.state.automation ? this.state.automation._id : ''}
                    automation={this.state.automation}
                    resources={isAccount ? this.props.accounts : opportunities}
                    showStats={this.handleShowStats}
                  />
                </div>
              </Tab>
              <Tab
                eventKey="resources"
                title={isAccount ? 'Accounts' : 'Opportunities'}
              >
                <div>
                  <p />
                  <ResourceTable
                    resources={isAccount ? this.props.accounts : this.props.opportunities}
                    isAccount={isAccount}
                    tableName={isAccount ? 'progress-account-table' : 'progress-opportunity-table'}
                    onStatusCellClick={this.handleStatusCellClick}
                  />
                  
                </div>
              </Tab>

              <Tab
                eventKey="contacts"
                title="Contacts"
              >
                <p />
                {loadPercentage === 1 && 
                  <ContactTable
                    ids={progressStats.allSubmitted?.ids}
                    automation={this.state.automation}
                  />
                }
                {loadPercentage !== 1 && 
                  <ProgressBar />
                }
              </Tab>
              
              <Tab
                eventKey="owners"
                title="Sales Reps"
              >
                <div>
                  <p />
                  <OwnerTable
                    isAccount={isAccount}
                    showStats={this.handleShowStats}
                  />
                </div>
              </Tab>

              <Tab
                eventKey="reminders"
                title="Reminders"
              >
                <div>
                  <p />
                  <ReminderTable
                    isAccount={isAccount}
                    showStats={this.handleShowStats}
                  />
                </div>
              </Tab>

            </Tabs>
          </div>
        }
        {!isAccount &&
          <OpportunityModal
            opportunityIds={this.state.selectedIds}
            getOpportunities={getWinLossOpportunities}
            tableConfigs={{
              tableName: 'progress-opportunity-table',
              getColDefs: this.getColDefs,
            }}
            onClose={() => {
              this.setState({ selectedIds: [] });
            }}
          />
        }
        {isAccount &&
          <AccountModal
            accountIds={this.state.selectedIds}
            getAccounts={getWinLossAccounts}
            tableConfigs={{
              tableName: 'progress-account-table',
              getColDefs: this.getColDefs,
            }}
            onClose={() => {
              this.setState({ selectedIds: [] });
            }}
          />
        }
        {this.renderModal()}
      </div>
    );
  }


  renderDateAnchorSelector() {
    const { automation, isAccount } = this.state;
    if (!automation || !automation.$has_date_filters) {
      return null;
    }
    const tip = (
      <Tooltip id="date-anchor">
        <div>
          Qualified {isAccount ? 'accounts' : 'opporutnities'} for automation "<strong>{automation.name}</strong>" will be tested based on this date.
        </div>
      </Tooltip>
    );
    return (
      <FormGroup className={styles.dateFormGroup}>
        <InputGroup>
          <InputGroup.Addon className="hidden-sm">Date check</InputGroup.Addon>
          <DatePicker
            dateFormat="DD MMM YYYY"
            className="form-control clickable"
            selected={this.state.dateAnchor ? this.state.dateAnchor : null}
            showYearDropdown
            scrollableYearDropdown
            placeholderText="Date check"
            onChange={(d) => {
              this.setState({ dateAnchor: d });
            }}
          />
          <InputGroup.Addon>
            <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={tip}>
              <Fa name="info-circle" className="text-active" />
            </OverlayTrigger>
          </InputGroup.Addon>
        </InputGroup>
      </FormGroup>
    );
  }

  render() {
    const {
      loaded, loading,
      feedbackRequestSettings,
    } = this.props;
    const { isAccount, hasReset } = this.state;
    const isLoading = !loaded || loading;
    const includeOpenOpportunities = feedbackRequestSettings.include_open_opportunities === true;
    const hasAutomations = this.state.automations.length > 0 && this.state.automation;

    let items = null;

    if (includeOpenOpportunities) {
      items = [];
      items.push((
        <IncludeOpenOpportunities
          path={2}
          level={1}
          includeOpenOpportunities={includeOpenOpportunities}
          showDelete={false}
          showInclude={false}
          searchCriteria={{
            _id: 'open-opportunities',
            type: 'include',
            filter: {
              _id: 'open-opportunities',
              label: 'Open Opportunities',
            },
          }}
        />
      ));
    }


    let defaultCriteria = {
      type: 'groupAND',
      values: [
        {
          tag: 'closeDate',
          type: 'include',
          values: 'last-90-days',
        },
      ],
    };

    if (this.state.automation && !hasReset) {
      const lookback = this.state.automation.full_automation_lookback_period;
      const searchQuery = this.state.automation.search_query;
      let dateValues = 'last-90-days';
      if (lookback) {
        const now = moment().format('YYYY-MM-DD');
        const start = moment().subtract(lookback, 'days').format('YYYY-MM-DD');
        dateValues = [start, now];
      }
      defaultCriteria = {
        type: 'groupAND',
        values: [
          {
            id: 'ROOT',
            tag: 'closeDate',
            type: 'include',
            values: dateValues,
          },
          ...(Array.isArray(searchQuery) ? searchQuery : [searchQuery]).filter(Boolean),
        ],
      };
    }

    const topComponent = (
      <div className="clearfix">
        <div className="pull-left">
          <SubNav />
        </div>
        {!this.state.loading && hasAutomations &&
          <div className="pull-right">
            <SearchForm
              key={`${this.state.automation._id}-${hasReset ? '1' : '0'}`}
              onSearchChange={this.handleFormChange}
              onReset={this.hanldeReset}
              pullRight
              requireTeamSelector={false}
              selectDefaultTeam
              source={isAccount ? 'account' : 'opportunity'}
              type={isAccount ? 'feedback/progress-account' : 'feedback/progress-opportunity'}
              defaultCriteria={defaultCriteria}
              disabledFilters={[]}
              disabled={isLoading}
              loadRecommendedCriteria={false}
            >
              {items}
            </SearchForm>
          </div>
        }
      </div>
    );
    
    return (
      <div className="container">
        <BodyClassName className={styles.body} />
        <Helmet title="Progress | Feedback" />
        <RequiredTVCollectorMappingSetup types={['decision', 'experience']}>
          {() => {
            return (
              <>
                <div>
                  <div>{topComponent}</div>
                  <p />
                  {!this.state.loading && 
                    <div className={`well ${styles.automationPicker}`}>
                      <table>
                        <tbody>
                          <tr>
                            <td>
                              <AutomationSelector
                                automations={this.state.automations}
                                automation={this.state.automation}
                                selectAutomation={this.handleSelectAutomation}
                              />
                            </td>
                            <td>
                              {this.renderDateAnchorSelector()}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  }
                  {this.state.loading && <ProgressBar />}
                  <p />
                </div>
                {hasAutomations &&
                  <div>
                    {(isLoading || this.state.loading) && <div><ProgressBar /></div>}
                    {!(isLoading || this.state.loading) && this.state.ready && this.renderResults()}
                  </div>
                }
              </>
            );
          }}
        </RequiredTVCollectorMappingSetup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getWinLossLoading(state),
    loaded: getWinLossLoaded(state),
    errors: getWinLossErrors(state),
    opportunities: getWinLossOpportunities(state),
    feedbackRequestSettings: getFeedbackRequestSettings(state),
    progressStats: getProgressStats(state),
    progressLoadError: getProgressLoadError(state),
    accounts: getWinLossAccounts(state),
    auth: getUser(state),
    loadPercentage: getProgressLoadPercentage(state),
  };
}

ProgressPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  progressLoadError: PropTypes.bool,
  errors: PropTypes.shape({}),
  opportunities: PropTypes.arrayOf(PropTypes.shape({})),
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
  feedbackRequestSettings: PropTypes.shape({
    include_open_opportunities: PropTypes.bool,
  }),
  loadPercentage: PropTypes.number,
  auth: PropTypes.shape({}).isRequired,
};

ProgressPage.defaultProps = {
  loading: false,
  loaded: false,
  errors: null,
  opportunities: [],
  feedbackRequestSettings: {
    include_open_opportunities: false,
  },
  progressStats: PropTypes.shape({
  }).isRequired,
  
  progressLoadError: false,
};

ProgressPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};
export default connect(mapStateToProps)(withRouter(ProgressPage));
